import type { WhatsNewEntry } from "../types";

/**
 * Release note: take-you-there — 小环 brings you to the right usage (2026-06-30).
 * R2 wave (页面引导 loom-guide + 媒体 media). PRE-STAGED + flag-gated: committed
 * here but shown only when FEATURE_IA_LOOM_GUIDE is on (WhatsNew gates by /healthz
 * features.loomGuide). Premium `sections` layout (like code-qa), kept lean per the
 * locked killer 口径: organize by the user's stuck-moment, not a capability list;
 * 不讲能力升级, 讲「不靠你会问, 小环用页面/演示/案例把你带到对的用法上」.
 * Scene `shot`s are real product screenshots (captured from the running app).
 */
export const takeYouThere: WhatsNewEntry = {
  id: "2026-06-30-take-you-there",
  date: "2026-06-30",
  flag: "loomGuide",
  kicker: "发布说明",
  title: "小环 · 带你用对",
  subtitle: "Guided, not guessed",
  video: "/whatsnew/take-you-there.mp4",
  summary:
    "织灵里的事在哪做、怎么做，不用先学会怎么问——小环用页面、演示、案例把你带到对的用法上。",
  sections: [
    {
      kind: "prose",
      md: "今天起，织灵里的事在哪做、怎么做，不用你先学会怎么问——**小环带你用对**。\n\n直接在小环里问，研发、产品、运营、售前都用得上。"
    },
    {
      kind: "scene",
      eyebrow: "知道有这功能，就是找不到",
      heading: "你说个大概，它把那一页递到你面前",
      copy: "「成员在哪加？」「模型在哪配？」以前你得自己翻菜单，或者照着「先去 A、再进 B、最后点 C」慢慢找——一步走岔就得重来。现在小环告诉你页面长什么样、入口在哪，点一下就进你自己的织灵，角色、权限、版本都对得上。",
      shot: "/whatsnew/take-you-there-guide.png"
    },
    {
      kind: "scene",
      eyebrow: "想照着别人做，却没处看",
      heading: "调出真有人做过的一遍，照着走",
      copy: "有些事解释半天，不如看一遍。问「这个怎么用、有没有案例可以参考」，小环给你一段真实的操作演示——从哪里进、点了什么、怎么配、最后看到什么结果，每一步都看得到，你跟着来就行。",
      shot: "/whatsnew/take-you-there-media.png"
    },
    { kind: "quote", md: "不用先变成会提问的人。你说个大概，剩下的交给小环带。" },
    { kind: "prose", md: "期待你的反馈，我们继续打磨。" }
  ]
};
